import { types } from 'mobx-state-tree';
const optionalMaybeNull = (T) => types.optional(types.maybeNull(T), null);

export const PassolutionSelection = types
  .model('PassolutionSelection', {
    nationality: types.optional(types.string, ''),
    destinations: types.array(optionalMaybeNull(types.string, '')),
    origin: types.optional(types.string, ''),
  })
  .actions((self) => ({
    setNationality: (nationality) => (self.nationality = nationality),
    setDestinations: (destinations) => (self.destinations = destinations),
    setOrigin: (origin) => (self.origin = origin),
  }));
